import styled from "styled-components";
import theme from "../../../UI/theme";

const ClearMenuBarContainer = styled.div`
    @media only screen and (max-width: ${theme.screenSizes.medium - 1}px) {
        margin-bottom: 85px;
    }
`

export default ClearMenuBarContainer;